import axios from 'axios';
import authHeader from "@/service/auth-header";

class TaskService {

    async getCompanyActiveTasks(companyId) {
        return await axios.get(`/api/task/active/${companyId}`, {headers: authHeader()})
    }

    async getCompanyTasksLazyLoading(companyId, userId, params, search, status, type, category, filter, start, end) {
        try {
            const newParams = {};

            if (params.sortField) {
                newParams.sortField = params.sortField;
            } else {
                newParams.sortField = "due";
            }

            if (params.sortOrder) {
                newParams.sortOrder = params.sortOrder;
            } else {
                newParams.sortOrder = "desc";
            }

            if (search) {
                newParams.search = search;
            }

            if (status) {
                newParams.status = status;
            }

            if (type) {
                newParams.type = type;
            }

            if (category) {
                newParams.category = category;
            }

            if (filter) {
                newParams.filter = filter;
            }

            if (userId) {
                newParams.userId = userId;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            newParams.page = params.first/params.rows + 1;
            newParams.size = params.rows;

            var apiString = `/api/task/lazyloading/${companyId}`;

            // console.log("[TaskService][getCompanyTasksLazyLoading] ",
            //     "page =", newParams.page,
            //     ", size =", newParams.size,
            //     ", sort =", newParams.sortField,
            //     ", order =", newParams.sortOrder,
            //     ", search =", newParams.search,
            //     ", status =", newParams.status,
            //     ", type =", newParams.type,
            //     ", category =", newParams.category,
            //     ", filter =", newParams.filter,
            //     ", userId =", newParams.userId,
            //     ", start =", newParams.start,
            //     ", end =", newParams.end,
            //     ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[TaskService][getCompanyTasksLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }


    async getCompanyCompleteTasks(companyId) {
        return await axios.get(`/api/task/complete/${companyId}`, {headers: authHeader()})
    }

    async getCompanyRecentCompleteTasks(companyId) {
        return await axios.get(`/api/task/complete/recent/${companyId}`, {headers: authHeader()})
    }

    async getCompanyandUserActiveTasks(companyId, userId) {
        return await axios.get(`/api/task/active/${companyId}/${userId}`, {headers: authHeader()})
    }

    async getCompanyAndClientAllTasks(companyId, clientId) {
        return await axios.get(`/api/task/all/${companyId}/client/${clientId}`, {headers: authHeader()})
    }

    async getTask(taskId) {
        return await axios.get(`/api/task/specific/${taskId}`, {headers: authHeader()})
    }

    async createTask(companyId, data) {
        return await axios.post(`/api/task/${companyId}`, data, {headers: authHeader()});
    }

    async updateTask(taskId, data) {
        return await axios.put(`/api/task/${taskId}`, data, {headers: authHeader()});
    }

    async deleteTask(taskId) {
        return await axios.delete(`/api/task/${taskId}`, {headers: authHeader()})
    }

}

export default new TaskService();
